import { Component, OnInit, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { ValidationService } from '../../../shared/services/validation.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Utility } from '../../../common/utility';
import { BaseService } from '../../../shared/services/base.service';
import { FormLabelComponent } from '../../../components/form/label/label.component';
import { FormMessageComponent } from '../../../components/form/message/message.component';
import { AppConstants } from '../../../shared/constants/constants';
import { AppMessages } from '../../../shared/constants/messages';
import { ManageMemoModel, MemoStatus } from '../../../models/centre/manage-memo.model';
import { ManageMemoService } from './manage-memo.service';
import { NewsModel } from '../../../models/centre/news.models';
import { DialogService } from '../../../shared/services/dialog.service';
import { UserType } from '../../../shared/constants/permission';

@Component({
  selector: 'modify-news-popup',
  templateUrl: 'modify-news-popup.component.html',
  providers: [ManageMemoService]
})

export class ModifyNewPopUpComponent implements OnInit {
  public title: string;
  modifyNewPopupForm: FormGroup;
  modifyNewPopupModel = new ManageMemoModel();
  id: any;
  public showAll = 'all';
  public selectedCountryArr = [];
  public selectedCentreArr = [];
  public selectedRoleArr = [];
  public isCentre = false;
  public isRole = false;
  public isSuccess = false;
  public countryData = [];
  public centreData = [];
  public roleData = [];
  public logoImage: File = null;
  public fileErrorMessage = ValidationService.getValidatorErrorMessage("invalidDocFile");
  public userType = UserType;
  public userInfo = {
    id: localStorage.getItem(AppConstants.activeLink.userId),
    userType: localStorage.getItem(AppConstants.localStorage.userType)
  };
  public publishedButton = 'Publish';
  constructor(
    private formBuilder: FormBuilder,
    private baseService: BaseService,
    public utility: Utility,
    private managepMemoService: ManageMemoService,
    public dialogRef: MdDialogRef<ModifyNewPopUpComponent>,
    public dialogService: DialogService,
    @Inject(MD_DIALOG_DATA) public data: any) {

  }

  ngOnInit() {

    this.id = this.data.id;
    let param1 = {
      id: localStorage.getItem(AppConstants.activeLink.userId),
      userType: localStorage.getItem(AppConstants.localStorage.userType)
    };
    this.managepMemoService.getAllCountry(param1).subscribe(
      result => {
        if (result) {
          const data = result.json();
          this.countryData = data;
          this.updateAllToCountryData();
        }
      }
    );
    this.managepMemoService.getAllRole().subscribe(
      result => {
        if (result) {
          const data = result.json();
          this.roleData = data;
          this.updateAllToRoleData();
        }
      }
    );

    if (this.id) {
      this.title = 'Update Memo';
      this.managepMemoService.getMemoById(this.id).subscribe(
        result => {
          if (result) {
            const data = result.json();
            this.modifyNewPopupModel = data;
            this.modifyNewPopupModel.clinicLogoName = data['fileName'];
            this.centreData = data['centres'];
            this.modifyNewPopupForm.controls['isPublish'].setValue(this.modifyNewPopupModel.isPublish);
            if (this.modifyNewPopupModel.isPublish) {
              this.publishedButton = 'Unpublish';
              this.modifyNewPopupForm.disable();
            } else {
              this.publishedButton = 'Publish';
            }
            this.selectedCountryArr = this.modifyNewPopupModel.country;
            this.updateAllToCountryData();
            this.updateAllToCentreData();
            this.updateAllToRoleData();
          }
        }
      );
    } else {
      this.title = 'Add New Memo';
    }
    this.createForm();
  }

  updateAllToCountryData() {
    if (this.userInfo.userType !== this.userType.SystemAdmin && this.centreData.length > 0) {
      this.isCentre = true;
      ValidationService.attachRequired(this.modifyNewPopupForm.controls['centre'], []);
    } else if (this.modifyNewPopupModel.country && this.countryData.length > 0 && this.modifyNewPopupModel.country.length > 0) {
      if (this.countryData.length === this.modifyNewPopupModel.country.length) {
        this.modifyNewPopupModel.country.unshift(this.showAll);
        // set centre array to null
        this.modifyNewPopupForm.controls['centre'].setValue([]);
        this.modifyNewPopupModel.centre = [];
        this.selectedCentreArr = [];
        // set role array to null
        this.modifyNewPopupForm.controls['role'].setValue([]);
        this.modifyNewPopupModel.role = [];
        this.selectedRoleArr = [];
      } else {
        this.isCentre = true;
        ValidationService.attachRequired(this.modifyNewPopupForm.controls['centre'], []);
      }
    }
  }

  updateAllToCentreData() {
    if (this.userInfo.userType !== this.userType.SystemAdmin) {
      this.isRole = true;
      ValidationService.attachRequired(this.modifyNewPopupForm.controls['role'], []);
    } else if (this.modifyNewPopupModel.centre && this.centreData.length > 0 && this.modifyNewPopupModel.centre.length > 0) {
      if ((this.centreData.length === this.modifyNewPopupModel.centre.length &&
        this.userInfo.userType !== this.userType.SystemAdmin)
        || (this.centreData.length === this.modifyNewPopupModel.centre.length) && this.modifyNewPopupModel.centre.length > 1) {
        this.modifyNewPopupModel.centre.unshift(this.showAll);
        // set role array to null
        this.modifyNewPopupForm.controls['role'].setValue([]);
        this.modifyNewPopupModel.role = [];
        this.selectedRoleArr = [];
      } else {
        this.isRole = true;
        ValidationService.attachRequired(this.modifyNewPopupForm.controls['role'], []);
      }
    }
  }

  updateAllToRoleData() {
    if (this.modifyNewPopupModel.role && this.roleData.length > 0 && this.modifyNewPopupModel.role.length > 0) {
      if (this.roleData.length === this.modifyNewPopupModel.role.length) {
        this.modifyNewPopupModel.role.unshift(this.showAll);
      }
    }
  }

  createForm() {
    this.modifyNewPopupForm = this.formBuilder.group({
      title: ['', [Validators.required]],
      memo: ['', [Validators.required]],
      attachment: [''],
      country: ['', Validators.required],
      centre: [''],
      role: [''],
      clinicLogoName: '',
      IsClinicLogoDelete: false,
      isPublish: [false],
      isActive: [true],
      isConfirm: [false],
      CentreCreateId: [localStorage.getItem(AppConstants.localStorage.centreId)],
      CentrePublished: [localStorage.getItem(AppConstants.localStorage.centreName)]
    });
  }

  onClose() {
    this.dialogRef.close(this.isSuccess);
  }

  getCentre(param) {
    this.managepMemoService.getAllCentre(param).subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          this.centreData = data;
        }
      }
    );
  }

  controlShowAll(value, formControl, formModel, backupArr, selectData, isRole = false) {
    if (this.userInfo.userType !== this.userType.SystemAdmin && isRole === false) {
      return value;
    }
    if (value.length === 0) {
      formModel = [];
    } else if (value[0] === this.showAll) {
      let countryArr;
      // if show all is selected then select all item
      if ((backupArr.length > 0 && backupArr[0] !== this.showAll)
        || backupArr.length === 0) {
        countryArr = [this.showAll];
        selectData.forEach(d => {
          countryArr.push(d.id);
        });
      } else if (value.length <= selectData.length) {
        // if user unselect any item then un-selected show all
        countryArr = formModel;
        countryArr.splice(0, 1);
      }
      formModel = countryArr;
    } else if (value[0] !== this.showAll && backupArr[0] === this.showAll) {
      // if show all is un-selected then un-select all item
      formModel = [];
    } else if (value.length === selectData.length) {
      // if user check all item then select all must be checked
      let countryArr = [this.showAll];
      selectData.forEach(d => {
        countryArr.push(d.id);
      });
      formModel = countryArr;
    }
    return formModel;
  }

  onCountryChange(event) {
    const value = event.value;
    let formModel = value;
    if (this.countryData.length > 1) {
      formModel = this.controlShowAll(value, this.modifyNewPopupForm.controls['country'],
        this.modifyNewPopupModel.country, this.selectedCountryArr, this.countryData);
    }
    this.modifyNewPopupForm.controls['country'].setValue(formModel);
    this.modifyNewPopupModel.country = formModel;
    // reset selectedCountryArr to used in next select
    this.selectedCountryArr = formModel;
    // if country is selected then show centre
    if (this.modifyNewPopupModel.country.length > 0 && this.modifyNewPopupModel.country[0] !== this.showAll) {
      this.isCentre = true;
      ValidationService.attachRequired(this.modifyNewPopupForm.controls['centre'], []);

      const param = {
        id: localStorage.getItem(AppConstants.activeLink.userId),
        userType: localStorage.getItem(AppConstants.localStorage.userType),
        countries: this.modifyNewPopupForm.controls['country'].value
      };

      this.getCentre(param);
    } else {

      this.isCentre = false;
      ValidationService.removeRequired(this.modifyNewPopupForm.controls['centre'], []);
      // set centre array to null
      this.modifyNewPopupForm.controls['centre'].setValue([]);
      this.modifyNewPopupModel.centre = [];
      this.selectedCentreArr = [];
      // set role array to null
      this.isRole = false;
      ValidationService.removeRequired(this.modifyNewPopupForm.controls['role'], []);
      this.modifyNewPopupForm.controls['role'].setValue([]);
      this.modifyNewPopupModel.role = [];
      this.selectedRoleArr = [];
    }

  }

  onCentreChange(event) {
    const value = event.value;
    let formModel = value;
    if (this.centreData.length > 1) {
      formModel = this.controlShowAll(event.value, this.modifyNewPopupForm.controls['centre'],
        this.modifyNewPopupModel.centre, this.selectedCentreArr, this.centreData);
    }
    this.modifyNewPopupForm.controls['centre'].setValue(formModel);
    this.modifyNewPopupModel.centre = formModel;
    // reset selectedCountryArr to used in next select
    this.selectedCentreArr = formModel;

    if (this.modifyNewPopupModel.centre.length > 0 && this.modifyNewPopupModel.centre[0] !== this.showAll) {
      this.isRole = true;
      ValidationService.attachRequired(this.modifyNewPopupForm.controls['role'], []);
    } else {
      this.isRole = false;
      ValidationService.removeRequired(this.modifyNewPopupForm.controls['role'], []);
      // set role array to null
      this.modifyNewPopupForm.controls['role'].setValue([]);
      this.modifyNewPopupModel.role = [];
      this.selectedRoleArr = [];
    }

  }

  onRoleChange(event) {
    const value = event.value;
    let formModel = value;
    if (this.roleData.length > 1) {
      formModel = this.controlShowAll(event.value, this.modifyNewPopupForm.controls['role'],
        this.modifyNewPopupModel.role, this.selectedRoleArr, this.roleData, true);
    }
    this.modifyNewPopupForm.controls['role'].setValue(formModel);
    this.modifyNewPopupModel.role = formModel;
    // reset selectedCountryArr to used in next select
    this.selectedRoleArr = formModel;
  }

  onChangeLogo(event) {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      if (this.utility.isValidFile(file, AppConstants.uploadFileConfig.doc, 2)) {
        this.logoImage = file;
        //hide choose file button
        event.target.hidden = true;
        this.modifyNewPopupForm.controls["IsClinicLogoDelete"].setValue(false);
        this.modifyNewPopupForm.controls["clinicLogoName"].setValue(this.logoImage.name);
      }
      else {
        // show error popup
        this.dialogService.openErrorDialog({ message: this.fileErrorMessage });
      }
    }
  }

  onRemoveLogo(event) {
    this.modifyNewPopupForm.controls["IsClinicLogoDelete"].setValue(true);
    this.modifyNewPopupForm.controls["clinicLogoName"].setValue("");
    this.logoImage = null;
    this.modifyNewPopupModel.clinicLogoName = '';
    //get input file and set value to null
    var fileInput = event.target.parentElement.parentElement.nextElementSibling.nextElementSibling;
    fileInput.value = '';
  }

  onPublish() {
    // edit mode
    const message = this.modifyNewPopupModel.isPublish === true ? AppMessages.dialog.unpublishMessage : AppMessages.dialog.publishMessage;
    this.modifyNewPopupForm.enable();
    if (this.modifyNewPopupForm.valid) {
      this.dialogService.openConfirmationDialog({ message: message }).subscribe(
        (result) => {
          if (result) {
            if (this.data.id) {
              if (!this.modifyNewPopupModel.isPublish) {
                this.modifyNewPopupForm.controls['CentrePublished'].setValue(localStorage.getItem(AppConstants.localStorage.centreName));
              }
              this.modifyNewPopupForm.controls['isPublish'].setValue(!this.modifyNewPopupModel.isPublish);
            } else {
              // add mode
              this.modifyNewPopupForm.controls['isPublish'].setValue(true);
            }
            this.onSubmit();
          }
        });
    }

  }

  addMemo() {
    const formData = new FormData();
    if (this.logoImage) {
      formData.append('logoFile', this.logoImage, this.logoImage.name);
    }    
    this.filterShowAll();
    formData.append('data', JSON.stringify(this.modifyNewPopupForm.value));
    this.managepMemoService.addNewMemo(formData).subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          this.dialogService.openSuccessDialog({ message: data.message });
          this.isSuccess = true;
          this.onClose();
        }
      },
      error => {

      }
    );
  }

  updateMemo() {
    const formData = new FormData();
    if (this.logoImage) {
      formData.append('logoFile', this.logoImage, this.logoImage.name);
    }
    this.filterShowAll();
    formData.append('data', JSON.stringify(this.modifyNewPopupForm.value));

    this.managepMemoService.updateMemo(this.data.id, formData).subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          this.dialogService.openSuccessDialog({ message: data.message });
          this.isSuccess = true;
          this.onClose();
        }
      },
      error => {

      }
    );
  }
  filterShowAll(){
    let data = this.modifyNewPopupForm.value;
    data['role'] = data['role'].filter(x => x !== this.showAll);
    data['centre'] = data['centre'].filter(x => x !== this.showAll);
    data['country'] = data['country'].filter(x => x !== this.showAll);
  }
  onSubmit() {
    if (this.modifyNewPopupForm.valid) {
      // edit mode
      if (this.data.id) {
        this.updateMemo();
      } else {
        this.addMemo();
      }
    }
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/manage-memo/modify-news-popup.component.ts